import * as CONSTANTS from "../constants/constants";
import {getPoolUserBuffer} from "./idoHelper";
import {PublicKey} from "@solana/web3.js";
import {ASSOCIATED_PROGRAM_ID, TOKEN_PROGRAM_ID} from "@coral-xyz/anchor/dist/cjs/utils/token";


export const findMainDataPDA = (programId) => {
    return PublicKey.findProgramAddressSync(
        [Buffer.from(CONSTANTS.PROD_NEW_IDO_PROGRAM_NAME)],
        programId
    )[0];
}

export const findUserPDA = (walletPubkey, programId) => {
    return PublicKey.findProgramAddressSync(
        [
            walletPubkey.toBuffer(),
            Buffer.from(CONSTANTS.PROD_NEW_IDO_PROGRAM_NAME),
            getPoolUserBuffer()
        ],
        programId
    )[0];
}

export const findStarVaultPDA = (programId, idoName) => {
    return PublicKey.findProgramAddressSync(
        [Buffer.from(idoName), Buffer.from('star_vault')],
        programId
    )[0];
}

export const findTokenVaultPDA = (programId, idoName) => {
    return PublicKey.findProgramAddressSync(
        [Buffer.from(idoName), Buffer.from('token_vault')],
        programId
    )[0];
}

export const findUsdcVaultPDA = (programId, idoName) => {
    return PublicKey.findProgramAddressSync(
        [Buffer.from(idoName), Buffer.from('usdc_vault')],
        programId
    )[0];
}

export const findPoolPDA =(programId, idoName) => {
    return PublicKey.findProgramAddressSync(
        [Buffer.from(idoName)],
        programId
    )[0];
}

export const findParticipantPDA = (walletPubkey, programId, idoName) => {
    return PublicKey.findProgramAddressSync(
        [
            walletPubkey.toBuffer(),
            Buffer.from(idoName),
            Buffer.from("pool_participant")
        ],
        programId
    )[0];
}

export const findManagerTokenAccountPDA = (walletPubkey, tokenMintKey) => {

    return PublicKey.findProgramAddressSync([
            walletPubkey.toBuffer(),
            TOKEN_PROGRAM_ID.toBuffer(),
            tokenMintKey.toBuffer()],
        ASSOCIATED_PROGRAM_ID)[0];
}


export const findUserUsdcPDA = (walletPubkey, usdcMintKey) => {
    return PublicKey.findProgramAddressSync([
            walletPubkey.toBuffer(),
            TOKEN_PROGRAM_ID.toBuffer(),
            usdcMintKey.toBuffer()],
        ASSOCIATED_PROGRAM_ID)[0];
}

export const findUserStarsPDA = (walletPubkey, starMintKey) => {
    return PublicKey.findProgramAddressSync([
            walletPubkey.toBuffer(),
            TOKEN_PROGRAM_ID.toBuffer(),
            starMintKey.toBuffer()],
        ASSOCIATED_PROGRAM_ID)[0];
}

export const findUserTokenAccountPDA = (walletPubkey, tokenMintKey) => {
    return PublicKey.findProgramAddressSync([
            walletPubkey.toBuffer(),
            TOKEN_PROGRAM_ID.toBuffer(),
            tokenMintKey.toBuffer()],
        ASSOCIATED_PROGRAM_ID)[0];
}